<template>
  <div id="listWidget" class="mb-4" style="padding-bottom: 5rem;">
    <div>
      <!-- <h4 class="mb-3">이관하기</h4> -->
      
      <!-- 이관 단계 안내 -->
      <div class="instruction-card card-item mb-3">
        <div class="instruction-header">
          <i class="fa-solid fa-list-ol me-2 text-primary"></i>
          <span class="instruction-title">이관 단계</span>
        </div>
        <div class="instruction-body">
          <div class="instruction-step">
            <div class="step-number">1</div>
            <div class="step-content">
              <span>이관 받을 사용자의 <strong class="text-primary">공유코드</strong>를 입력해주세요.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-number">2</div>
            <div class="step-content">
              <span>이관할 영역을 <strong class="text-primary">체크박스</strong>에 체크해주세요.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-number">3</div>
            <div class="step-content">
              <span>아래의 <strong class="text-primary">이관 버튼</strong>을 눌러서 다른 사용자에게 설정 정보를 이관해주세요. 이관 받은 사용자는 필요에 따라 <strong class="text-primary">wifi 변경</strong>이 필요할 수 있습니다.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 공유코드 입력 카드 -->
    <div class="input-card card-item mb-3">
      <div class="input-card-header">
        <i class="fa-solid fa-key me-2 text-primary"></i>
        <span class="input-card-title">공유코드 입력</span>
      </div>
      <div class="input-card-body">
        <input
          type="text"
          class="form-control form-control-lg"
          placeholder="설정 정보를 받을 사용자 공유코드를 입력해주세요."
          v-model="sharedCode"
        />
      </div>
    </div>

      <!-- 이관 영역 선택 카드 -->
      <div class="zone-select-card card-item mb-3">
      <div class="zone-select-card-header">
        <i class="fa-regular fa-square-check me-2 text-primary"></i>
        <span class="zone-select-card-title">이관 영역 선택</span>
      </div>
      <div class="zone-select-card-body">
        <div
          class="zone-item"
          v-for="(zone, index) in zones"
          :key="zone._id"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              :id="`gridCheck${index}`"
              :value="zone._id"
              @change="onSelectZoneChange"
            />
            <label class="form-check-label" :for="`gridCheck${index}`">
              {{ zone.name }}
            </label>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>

  <!-- 이관 버튼 (하단 고정) -->
  <div class="action-button-container-fixed">
    <button
      type="button"
      class="btn btn-primary w-100"
      @click="onTransferClick"
    >
      <i class="fa-regular fa-share-from-square me-2"></i>
      이관
    </button>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { DeviceDefault } from '@/common/constants';
import Axios, { CtrlApi, ZoneApi, AuthApi } from '@/api';

const store = useStore();
const router = useRouter();
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;

const sharedCode = ref('');
const selectedZones = ref([]);
const account = computed(() => store.getters['account']);
const zones = computed(() => store.getters['home/getZones'].filter(
  (zone) => zone.ownerId === account.value._id
));
const sharedZones = computed(() => zones.value.filter(zone => zone.ownerId != account.value._id));

const onSelectZoneChange = (e) => {
  const targetIndex = selectedZones.value.findIndex(
    (item) => item == e.target.value,
  );
  if (targetIndex >= 0) {
    selectedZones.value = selectedZones.value.filter(
      (item) => item != e.target.value,
    );
  } else {
    selectedZones.value.push(e.target.value);
  }
};

const requestTransferSend = (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      // logger.log(
      //   `TransferSendPage.requestTransferSend => params : ${JSON.stringify(
      //     params,
      //   )}`,
      // );

      const result = await Axios.patch(CtrlApi.TRANSFER_SEND_CTRL, params);
      if (result.resultCode === '0000') {
        // logger.log(
        //   `TransferSendPage.requestTransferSend => result : ${JSON.stringify(
        //     result,
        //   )}`,
        // );
        resolve(result);
        return;
      }

      reject(result.resultMessage);
    } catch (e) {
      console.log(e);
      reject('컨트롤러 이관 중 오류가 발생하였습니다.');
    }
  });
};

const requestCancelShareAll = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.post(AuthApi.CANCEL_SHARE_ALL, { id }, 'auth');
      if (result.resultCode === '0000') {
        resolve(result);
      } else {
        reject(result.resultMessage);
      }
    } catch (error) {
      reject(error);
    }
  });
};

const onTransferClick = async () => {
  if (sharedZones.value.length > 0) {
    emitter.emit('showPopAlert', {
      description: '공유받은 사용자는 다른 사용자에게 이관할 수 없습니다.',
    });
    return;
  }
  if (sharedCode.value.length === 0) {
    emitter.emit('showPopAlert', {
      description: '공유코드를 입력해주세요.',
    });
    return;
  }
  if (selectedZones.value.length === 0) {
    emitter.emit('showPopAlert', {
      description: '이관 영역을 선택해주세요.',
    });
    return;
  }

  const transferSend = async () => {
    await requestTransferSend({
      userId: account.value._id,
      sharedCode: sharedCode.value,
      zones: selectedZones.value,
    });
    await store.dispatch('home/fetchAllZones');

    emitter.emit('showPopAlert', {
      description: '이관이 완료되었습니다.',
      okCallback: () => router.go(-1),
    });
  }

  console.log('account.value.sharedUsers =>',account.value.sharedUsers)

  try {
    if (account.value.sharedUsers?.length > 0) {
      emitter.emit('showPopConfirm', {
        description: '이관을 하면 공유 정보가 모두 초기화됩니다.\n계속 하시겠습니까?',
        okCallback: async () => {
          const result = await requestCancelShareAll(account.value._id);
          if(result.resultCode === '0000'){
            transferSend();
          }
        }
      });
      return;
    }
    
    transferSend();
  } catch (e) {
    emitter.emit('showPopAlert', {
      description: e,
    });
  }
};

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'이관하기',isShowMenu:false,isShowZone:false,isShowProfile:false});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})
</script>

<style scoped>
/* instruction-card 스타일 */
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.instruction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: #495057;
}

.step-content strong {
  color: #0d6efd;
  font-weight: 600;
}

/* input-card 스타일 */
.input-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.input-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.input-card-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.input-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.input-card-body {
  padding: 1rem;
}

.input-card-body input {
  font-size: 0.875rem;
}

.input-card-body input::placeholder {
  font-size: 0.875rem;
}

/* zone-select-card 스타일 */
.zone-select-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.zone-select-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.zone-select-card-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.zone-select-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.zone-select-card-body {
  padding: 0.75rem 1rem;
}

.zone-item {
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.zone-item:last-child {
  border-bottom: none;
}

.zone-item .form-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.zone-item .form-check-label {
  font-size: 0.9rem;
  color: #212529;
  cursor: pointer;
  flex: 1;
}

/* action-button-container 스타일 */
.action-button-container {
  margin-top: 0;
}

.action-button-container .btn {
  padding: 0.75rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-button-container .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.action-button-container .btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 하단 고정 버튼 스타일 */
.action-button-container-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background-color: #ffffff;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.action-button-container-fixed .btn {
  padding: 0.75rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-button-container-fixed .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.action-button-container-fixed .btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 모바일 반응형 간격 조정 */
@media (max-width: 768px) {
  #listWidget {
    margin-bottom: 1rem;
    padding-bottom: 5.5rem;
  }

  .instruction-card,
  .input-card,
  .zone-select-card {
    margin-bottom: 1rem;
  }

  .action-button-container-fixed {
    padding: 0.875rem;
  }

  .action-button-container-fixed .btn {
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
  }
}
</style>
